import {APIRequest} from "./APIRequest.js";
import {getVerboseElapsed} from "./getVerboseElapsed.js";
export async function refreshNotifications() {
	var request = new APIRequest();
	request.set('getSession');
	var data = (await request.send()).getSession;
	if (data.error) location.href = 'index.php';

	if (data.data.unread_messages) {
		$("#topbar-messages-dd").html(`<i class="fas fa-envelope fa-fw"></i><span class="badge badge-danger badge-counter">${data.data.unread_messages}</span>`);
	} else {
		$("#topbar-messages-dd").html(`<i class="fas fa-envelope fa-fw"></i>`);
	}

	if (data.data.notifications) {
		if (!data.data.notifications.length) {
			$("#alertsDropdown").find(".badge-counter").hide();
			$("#alertsDropdown").parent().find(".dropdown-list").html(`<h6 class="dropdown-header">
				Notifications Center
			</h6><span class="dropdown-item d-flex align-items-center">
					<div>
						<span class="font-weight-bold" style='display:block'>No notifications at this time.</span>
					</div>
				</span>
				<p class='text-center mt-2'><a href='notifications.php'>Notifications Center</a></p>`);
		} else {
			var total = data.data.notifications.length;
			var sliced = data.data.notifications.slice(0, 5);

			$("#alertsDropdown").find(".badge-counter").html(data.data.notifications.length).show();
			$("#alertsDropdown").parent().find(".dropdown-list").html(`<h6 class="dropdown-header">
				Notifications Center
			</h6>${sliced.map(notification => {
				return `<a class="dropdown-item d-flex align-items-center notification-link" href="#" data-id=${notification.id}>
					<div class="mr-3">
						<div class="icon-circle bg-primary">
							<img class="img-profile rounded-circle my-profile-img" src="${notification.icon}" style="width:2rem;">
						</div>
					</div>
					<div>
						${+notification.sent_time === 0 ? '' : `<div class="small text-gray-500">Sent: ${getVerboseElapsed(+notification.sent_time)}</div>`}
						<span class="font-weight-bold" style='display:block'>${notification.title}</span>
						<small>${notification.body}</small>
					</div>
				</a>`;
			}).join('')}${total > 5 ? `
				<p class='text-center mt-2'><a href='notifications.php'>+${total - 5} More</a></p>
			` : `
				<p class='text-center mt-2'><a href='notifications.php'>Notifications Center</a></p>
			`}`);
		}
	}
}
